import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const CustomerAccountInfoComponent = ({ accounts, onInnerFormChange, selectedCustomers }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="PersonAccount"
            name="IsPersonAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsPersonAccount',
                selectedCustomers?.Account
              )
            }}
            type="checkbox"
            value={selectedCustomers?.Account?.IsPersonAccount}
          />
          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.Name',
                selectedCustomers?.Account
              )
            }}
            type="text"
            value={selectedCustomers?.Account?.Name}
          />
          <InputContainer
            label="Number Of Employees"
            name="NumberOfEmployees"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.NumberOfEmployees',
                selectedCustomers?.Account
              )
            }}
            type="number"
            value={selectedCustomers?.Account?.NumberOfEmployees}
          />
          <InputContainer
            label="Account"
            labelField="Name"
            list={accounts}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.AccountId',
                selectedCustomers?.Account
              )
            }}
            optionName="Choose Account"
            type="select"
            value={selectedCustomers?.Account?.AccountId}
            valueField="Id"
          />

        </div>
      }
      expandedPanel="accountInfo"
      headerTitle="Account Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Tax Exempt"
            name="IsTaxExempt"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'CustomerInfo.IsTaxExempt',
                selectedCustomers?.CustomerInfo
              )
            }}
            type="checkbox"
            value={selectedCustomers?.CustomerInfo?.IsTaxExempt}
          />
          <InputContainer
            label="Has Shopping CartItems"
            name="HasShoppingCartItems"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'CustomerInfo.HasShoppingCartItems',
                selectedCustomers?.CustomerInfo
              )
            }}
            type="checkbox"
            value={selectedCustomers?.CustomerInfo?.HasShoppingCartItems}
          />
          <InputContainer
            label="Require ReLogin"
            name="RequireReLogin"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'CustomerInfo.RequireReLogin',
                selectedCustomers?.CustomerInfo
              )
            }}
            type="checkbox"
            value={selectedCustomers?.CustomerInfo?.RequireReLogin}
          />
           <InputContainer
            label="System Account"
            name="IsSystemAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'CustomerInfo.IsSystemAccount',
                selectedCustomers?.CustomerInfo
              )
            }}
            type="checkbox"
            value={selectedCustomers?.CustomerInfo?.IsSystemAccount}
          />
        </div>
      }
      expandedPanel="Customer Info"
      headerTitle="Customer Info"
    />
  </>
)
export default CustomerAccountInfoComponent;
